import { useEffect } from 'react';

function useLoadPdf(webViewerInstance, pdfUrl) {
  useEffect(() => {
    if (webViewerInstance && webViewerInstance.current && webViewerInstance.current.UI) {
      webViewerInstance.current.UI.loadDocument(pdfUrl, { extension: 'pdf' });
    }
  }, [pdfUrl]);
}

export { useLoadPdf };
